var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomInvestment2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#CCA89B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.851 36.762h9.77a3.5 3.5 0 0 1 3.501 3.502v16.082H9.35V40.264a3.5 3.5 0 0 1 3.502-3.502zM35.246 25.564h9.769a3.5 3.5 0 0 1 3.502 3.502v27.28H31.744v-27.28a3.5 3.5 0 0 1 3.502-3.502zM57.595 14.367h9.769a3.5 3.5 0 0 1 3.502 3.502v38.477H54.093V17.869a3.5 3.5 0 0 1 3.502-3.502zM6.538 62.612c0-1.152.922-2.12 2.12-2.12h62.945c1.152 0 2.12.922 2.12 2.12 0 1.152-.922 2.12-2.12 2.12H8.658a2.144 2.144 0 0 1-2.12-2.12z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomInvestment2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-investment-2.5d46d644b2f603e9e2562e77f07f6307.svg";